export class SearchEnrollmentRequest {

    public email?: String;

    public identification?: String;

    public identificationValue?: String;

    public searchby?: String;

    public personType: String = "DW" //Value 2 just for test purpose, use "DW" once service allow filter by project;

}

interface IBuilder {
    buildEmail(email: string): this
    buildIdentification(identification: string): this
    buildIdentificationValue(identificationValue: string): this
    buildSearchBy(searchBy: string): this
    getResult(): SearchEnrollmentRequest
}

export class SearchEnrollmentBuilder implements IBuilder {
    // The Concrete Builder
    searchEnrollmentRequest: SearchEnrollmentRequest

    constructor() {
        this.searchEnrollmentRequest = new SearchEnrollmentRequest()
    }

    buildEmail(email: string) {
        this.searchEnrollmentRequest.email = email
        return this
    }

    buildIdentification(identification: string) {
        this.searchEnrollmentRequest.identification = identification
        return this
    }

    buildIdentificationValue(identificationValue: string) {
        this.searchEnrollmentRequest.identificationValue = identificationValue
        return this
    }

    buildSearchBy(searchBy: string) {
        this.searchEnrollmentRequest.searchby = searchBy
        return this
    }

    getResult() {
        return this.searchEnrollmentRequest
    }
}
